<template>
  <div>
    <a
      v-for="(banner, index) in banners"
      :key="index"
      :href="banner.url_to_redirect"
      class="banner"
      :style="`color: ${banner.text_color}; background-color: ${banner.bg_color}`"
    >
      <div class="section">{{ banner.left_text[lang] }}</div>
      <div class="section">
        <span class="banner-title">{{ banner.name }}</span>
        <span class="hidden lg:block">{{ banner.center_text[lang] }}</span>
        <span class="lg:hidden">{{ banner.mobile_center_text[lang] }}</span>
      </div>
      <div class="section">{{ banner.right_text[lang] }}</div>
    </a>
  </div>
</template>

<script>
import Axios from "axios";
export default {
  props: {
    currentRoute: {
      type: String,
      default: "",
    },
  },
  data: () => {
    return {
      banners: [],
      lang: window.appLocale
    };
  },
  beforeMount() {
    Axios.get("/api/banners")
      .then((res) => {
        this.banners = [...res.data];
      })
      .catch((err) => {
        console.log(err);
      });
  },
};
</script>

<style lang="scss" scoped>
.banner {
  .section {
    // width: 30%;
    font-size: .875rem;

    display: flex;
    justify-content: center;
    align-items: center;

    &:last-child{
        justify-content: flex-end;
    }
    &:first-child{
        justify-content: flex-start;
    }

    @media(max-width:992px){
        width: 100%;
        &:first-child, &:last-child{
            display: none;
        }
        font-size: .75rem;
    }

    .banner-title {
      background: black;
      font-weight: bold;
      color: white;
      padding: 3px 6px;
      margin-right: 12px;
      font-size: .875rem;

      @media(max-width:992px){
        font-size: .75rem;
    }
    }
  }
}
</style>